import React from 'react';
import { CliScope } from '../../types';
import { formatCentsAsDollars } from '../../utils/money';

// Convert reports converted tokens, analyze reports supported tokens.
// The other kind is always 0, so it shows as a dash.
export function tokensForOperation(operation: CliScope, kind: 'converted' | 'supported', value: number): string {
  const applies = kind === 'converted' ? operation === 'convert' : operation === 'analyze';
  return applies ? value.toLocaleString() : '—';
}

interface CostProps {
  operation: CliScope;
  cost: number | null;
  estimate: number | null;
}

// An estimate always carries a tilde, so it never reads as a frozen cost.
export function formatEstimateCents(cents: number | null | undefined): string {
  return cents == null ? '—' : `~${formatCentsAsDollars(cents)}`;
}

// Convert rows show the frozen cost. Analyze rows show the estimate.
export function CliCost({ operation, cost, estimate }: CostProps) {
  if (operation === 'convert') return <>{formatCentsAsDollars(cost)}</>;
  if (estimate == null) return <>—</>;
  return <span title="Estimated conversion cost">{formatEstimateCents(estimate)}</span>;
}

export const costLabel = (operation: CliScope) => (operation === 'convert' ? 'Cost' : 'Est. Conversion Cost');
